import React, { useCallback, useEffect, useState } from "react";
import { Content } from "../../components/Containers";
import List from "../../components/List";
import { useModal } from "../../context/ModalContext";
import DrinkCard from "./DrinkCard";
import { createDrink, deleteDrink, getDrink, searchDrinks, updateDrink } from "../../api/Drink";
import EditDrink from "./Edit";


export default function Drinks({ navigate }) {
  const { showModal } = useModal();
  const [query, setQuery] = useState("");
  const [all, setAll] = useState(false);
  const [page, setPage] = useState(0);
  const [data, setData] = useState({ content: [] });
  const [selected, setSelected] = useState();

  const load = useCallback(() => {
    const search = async () => setData(await searchDrinks(query, all, page));
    search();
  }, [query, all, page]);

  useEffect(() => {
    load();
  }, [query, all, page, load]);

  return (
    <>
      <Content>
        <List
          data={data}
          query={query}
          updateQuery={setQuery}
          status={all}
          updateStatus={setAll}
          statusList={[
            { label: "Todos", value: true },
            { label: "Ativos", value: false },
          ]}
          updatePage={setPage}
          onNew={() =>
            setSelected({
              nameBr: "",
              locked: false,
              icon: null,
              logo: null,
            })
          }
          Item={(item) => (
            <DrinkCard
              key={"ku" + item.id}
              drink={item}
              onEdit={async () => {
                const loaded = await getDrink(item);
                setSelected(loaded);
              }}
              onDelete={async () => {
                try {
                  await deleteDrink(item);
                  load();
                } catch (e) {
                  showModal("O tipo de bebida não pode ser apagado", "warn", 10);
                }
              }}
              onFilter={() => navigate("/categories", { state: { drinkId: item.id } })}
            />
          )}
        />
      </Content>
      <EditDrink
        selected={selected}
        onClose={() => setSelected(null)}
        onSave={async (drink) => {
          try {
            if (drink.id) {
              await updateDrink(drink);
            } else {
              await createDrink(drink);
            }
            setSelected(null);
            load();
          } catch (e) {
            showModal("Falha ao gravar tipo de bebida", "error", 10);
          }
        }}
      />
    </>
  );
}
